module.exports = __webpack_public_path__ + "img/bocrm_logo_2l.fa227238.png";